/** Branding info returned by GET /api/public/branding/info. Based on BrandingInfoResponse.java */
export interface BrandingInfo {
  brand: string;
  name: string;
}

/** Product name, used only as a fallback when the backend is unreachable. */
export const DEFAULT_BRAND_NAME = 'Kluby Fit';
